import type { BrowserFallbackRegistry } from './types'

export const baseBrowserFallbacks: BrowserFallbackRegistry = {
  base: {
    getPreferredHourCycle: () => null,
    showOpenDialog: () => ({ canceled: true, filePaths: [] }),
    getFileIcon: () => '',
  },
}
